import { LinkCreateState, LinkCreateActions } from './types'
import { Constants } from './constants'
import { BigNumber } from 'ethers'

const initialState: LinkCreateState = {
  loading: false,
  step: 'initial',
  initialized: false,
  // hardcode for Coinbase application USDC
  tokenAddress: null,
  tokenType: 'ERC20',
  tokenAmount: BigNumber.from(0),
  humanReadableAmount: '0',
  transferId: null
}

export function linkCreateReducer(
  state: LinkCreateState = initialState,
  action: LinkCreateActions
): LinkCreateState {
    switch (action.type) {
      case Constants.LINK_CREATE_SET_LOADING:
        return {...state, loading: action.payload.loading }
      case Constants.LINK_CREATE_SET_STEP:
        return {...state, step: action.payload.step }
      case Constants.LINK_CREATE_SET_INITIALIZED:
        return {...state, initialized: action.payload.initialized }
      case Constants.LINK_CREATE_SET_AMOUNT:
        return {...state, tokenAmount: action.payload.tokenAmount }
      case Constants.LINK_CREATE_SET_HUMAN_READABLE_AMOUNT:
        return {...state, humanReadableAmount: action.payload.humanReadableAmount }
      case Constants.LINK_CREATE_SET_TRANSFER_ID:
        return {...state, transferId: action.payload.transferId }
      case Constants.LINK_CREATE_SET_TOKEN_ADDRESS:
        return {...state, tokenAddress: action.payload.tokenAddress }
      default:
          return state;
    }
}